import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconTrophyTournament = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={40}
    fill="none"
    viewBox="0 0 48 40"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#000"
      fillOpacity={0.6}
      d="M46.188 6.484c0 .235 1.484 6.641-2.657 12.735-2.89 4.375-7.812 7.422-14.61 9.218-1.483.391-3.046 1.72-3.046 3.204v4.609h6.172c.937 0 1.797.86 1.797 1.875 0 1.094-.782 1.875-1.797 1.875H15.875C14.781 40 14 39.219 14 38.125c0-1.016.781-1.875 1.875-1.875h6.25l-.078-4.61c0-1.484-1.563-2.812-3.047-3.203-6.797-1.796-11.719-4.843-14.61-9.218-4.14-6.094-2.656-12.5-2.656-12.735C1.97 5.625 2.75 5 3.61 5H11.5a14.184 14.184 0 0 1 0-2.578C11.5 1.094 12.594 0 14 0h19.922c1.406 0 2.5 1.094 2.5 2.422.078.781.078 1.64 0 2.578h7.89c.86 0 1.641.625 1.876 1.484ZM7.516 17.188c1.796 2.734 4.687 4.843 8.515 6.406-2.89-4.532-4.062-10.157-4.531-14.844H5.25c-.078 1.875.078 5.234 2.266 8.438ZM24 27.5c4.297-4.844 8.75-9.453 8.672-23.75H15.25C15.172 18.047 19.625 22.656 24 27.5Zm16.406-10.313c2.188-3.203 2.344-6.562 2.266-8.437h-6.25c-.469 4.688-1.64 10.313-4.531 14.844 3.828-1.563 6.718-3.672 8.515-6.407Z"
    />
  </svg>
));
export default SvgIconTrophyTournament;
